import Transformer from "./../../transformer";

export default class RoadConceptJBTransformer extends Transformer {
  static fetch({
    id,
    name,
    code,
    detail,
    unit_measurement: unitMeasurement,
    family,
    sub_family: subFamily,
    ...roadConceptJB
  }) {
    const supplies = (roadConceptJB.supplies || []).map((supply) => {
      const supplyData = supply.supply;
      const supplyName = supplyData.name;
      const supplyType = supplyData.supply_type.name;
      const unitMeasurement = supplyData.unit_measurement.name;
      return {
        ...supply,
        quantity: +supply.quantity,
        price: +supplyData.camp_price,
        supply: supply.id,
        supplyName: supplyData.name,
        selected: false,
        supplyData,
        supplyName,
        supplyType,
        unitMeasurement,
      };
    });

    const suppliesSum = supplies.reduce(
      (sum, supply) => +supply.price * +supply.quantity + sum,
      0
    );

    return {
      id,
      name,
      code,
      detailName: detail.detail_name,
      detailId: detail.detail_id,
      detail,
      family,
      subFamily,
      unitMeasurementId:
        unitMeasurement.unit_measurement_id || unitMeasurement.id,
      unitMeasurementName:
        unitMeasurement.unit_measurement_name || unitMeasurement.name,
      unitMeasurementAbbr: unitMeasurement.abbr,
      unitMeasurement,
      unitPriceMXN: +roadConceptJB.unit_price_MXN,
      unitPriceUSD: +roadConceptJB.unit_price_USD,
      unitPriceEUR: +roadConceptJB.unit_price_EUR,
      basePrice: +roadConceptJB.base_price,
      comment: roadConceptJB.comment,
      description: roadConceptJB.description,
      internal_concept: roadConceptJB.internal_concept,
      supplies,
      suppliesSum,
      catalogId: roadConceptJB.catalog,
    };
  }

  static send(roadConceptJB) {
    return {
      id: roadConceptJB.id,
      name: roadConceptJB.name,
      code: roadConceptJB.code,
      detail: roadConceptJB.detailId,
      // detail_id: roadConceptJB.detailId,
      unit_measurement: roadConceptJB.unitMeasurementId,
      unit_price_MXN: roadConceptJB.unitPriceMXN,
      unit_price_USD: roadConceptJB.unitPriceUSD,
      unit_price_EUR: roadConceptJB.unitPriceEUR,
      base_price: roadConceptJB.basePrice,
      comment: roadConceptJB.comment,
      description: roadConceptJB.description,
      internal_concept: roadConceptJB.internal_concept,
      catalog: roadConceptJB.catalogId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/services/roadConceptJB.js